<template>
    <section
        ref="timeline"
        data-wow-delay="0.3s"
        :class="windowWidth <= 768 ? 'wow fadeIn' : null"
        class="timeline"
    >
        <header
            data-wow-delay="0.3s"
            :class="windowWidth > 768 ? 'wow fadeInRight' : null"
            class="timeline__intro"
        >
            <div class="timeline__heading-container">
                <slot name="heading"/>
            </div>
            <div class="timeline__copy-container">
                <slot name="copy"/>
            </div>
        </header>
        <div class="timeline__year-list-container">
            <select
                class="timeline__year-list"
                v-if="events"
                v-model="activeEvent"
            >
                <option
                    v-for="(event, index) in eventsSorted"
                    :value="event"
                    :key="index"
                    :class="event === activeEvent ? 'timeline__year-item--active' : null"
                    class="timeline__year-item"
                    v-text="event.year"
                />
            </select>
        </div>
        <ul @click="timelineActive = false" class="timeline__year-line-list">
            <li
                v-for="(event, index) in eventsSorted"
                :key="index"
                :class="event === activeEvent ? 'timeline__year-line-item--active' : null"
                class="timeline__year-line-item"
            >
                <button
                    class="timeline__year-line-button"
                    v-text="event.year"
                    @click="activeEvent = event"
                />
            </li>
        </ul>
        <section @click="timelineActive = false" class="timeline__events-container">
            <div>
                <ul
                    class="timeline__events"
                    :style="eventsStyles"
                >
                    <li
                        class="timeline__event"
                        :class="event === activeEvent ? 'timeline__event--active' : null"
                        v-for="(event, index) in events"
                        :key="index"
                        @click="activeEvent = event"
                    >
                        <article class="timeline__event-content">
                            <h4
                                class="timeline__event-year"
                                v-text="event.year"
                            />
                            <h5
                                class="timeline__event-heading"
                                v-text="event.heading"
                            />
                            <p
                                class="timeline__event-description"
                                v-text="event.description"
                            />
                        </article>
                    </li>
                </ul>
                <article class="timeline__events-reveal">
                    <div class="timeline__events-reveal-container">
                        <slot name="reveal-heading"/>
                        <slot name="reveal-copy"/>
                        <slot name="reveal-button"/>
                    </div>
                </article>
            </div>
        </section>
    </section>
</template>

<script>
export default {
    name: 'BrandTimeline',
    props: {
        events: {
            type: Array,
            required: true,
        },
        breakpoint: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            threshold: 0.5,
            windowWidth: 0,
            intervalId: null,
            rootmargin: '-50px',
            activeEvent: null,
            timelineActive: false,
        };
    },
    /* eslint-disable */
    computed: {
        eventsStyles() {
            if (this.windowWidth < this.breakpoint) {
                return {};
            }

            return {
                width: `${this.events.length * 440}px`,
                transform: `translate(${this.events.indexOf(this.activeEvent) * (-440)}px, 0px)`,
            };
        },
        eventsSorted() {
            return this.events.sort(this.sortByYear);
        },
    },
    methods: {
        nextEvent() {
            const activeEventIndex = this.events.indexOf(this.activeEvent);

            if (this.timelineActive) {
                this.activeEvent = activeEventIndex < this.events.length - 1
                    ? this.events[activeEventIndex + 1]
                    : this.activeEvent = this.events[0];
            }
        },
        intersect(entries) {
            const entry = entries.filter(({target}) => {
               return target === this.$refs.timeline;
            });

            if (entry[0].intersectionRatio > this.threshold && this.windowWidth > this.breakpoint) {
                 this.timelineActive = true;
                 this.intervalId = setInterval(this.nextEvent, 3000);
                 return;
            }

            this.timelineActive = false;
            clearInterval(this.intervalId);
        },
        getWindowWidth() {
            this.windowWidth = document.documentElement.clientWidth;
        },
        sortByYear(a, b) {
            if (a.year < b.year) {
                return 1;
            }

            if (a.year > b.year) {
                return -1;
            }

            return 0;
        },
    },
    mounted() {
        this.activeEvent = this.events[0];

        const io = new IntersectionObserver(
            this.intersect,
            {
                threshold: [0.5],
            },
        )

        io.POLL_INTERVAL = 100;
        io.observe(this.$refs.timeline);

        this.$nextTick(() => {
            window.addEventListener('resize', this.getWindowWidth);
            this.getWindowWidth();
        });
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.getWindowWidth);
    },
};
</script>



// WEBPACK FOOTER //
// BrandTimeline.vue?49321caa